import { ProjectHumanResourceApiModel } from '@/core/models/api/project-human-resource.model';

export interface ProjectHumanResourceState {
  items: ProjectHumanResourceApiModel[];
  loadedProjectId: number | null;
  loading: boolean;
  saving: boolean;
  error: any;
}

export const initialProjectHumanResourceState: ProjectHumanResourceState = {
  items: [],
  loadedProjectId: null,
  loading: false,
  saving: false,
  error: null,
};
